import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { quickEntry: Boolean }

  connect() {
    if (!this.quickEntryValue) return

    const disableField = (field) => {
      if (!field) return
      field.disabled = true
      field.removeAttribute("required")
    }

    const metaInputs = this.element.querySelectorAll(".meta-field-input")

    metaInputs.forEach((input) => {
      if (!input.closest(".custom-dropdown-wrapper")) {
        disableField(input)
      }
    })

    const customDropdownWrappers = this.element.querySelectorAll(".custom-dropdown-wrapper")
    customDropdownWrappers.forEach((wrapper) => {
      disableField(wrapper.querySelector(".dropdown-selector"))
      disableField(wrapper.querySelector(".custom-text-field"))
    })

    const autocompleteInputs = this.element.querySelectorAll(
      'el-autocomplete input[data-autocomplete-search="true"]'
    )
    autocompleteInputs.forEach((input) => {
      if (input.classList.contains("meta-field-input")) {
        disableField(input)
      }
    })
  }
}
